import ErrorMessage from '@/components/common/ErrorMessage';
import FormButtons from '@/components/common/Form/FormButtons';
import CardLayout from '@/components/Layout/CardLayout';
import FieldLayout from '@/components/Layout/FieldLayout';
import Layout from '@/components/Layout/Layout';
import BackButton from '@/components/ui/BackButton';
import Label from '@/components/ui/Label';
import PrimaryInput from '@/components/ui/PrimaryInput';
import SearchSelectBox, {
  ISelectOption,
} from '@/components/ui/SearchSelectBox';
import { menuBars, showToastNotification } from '@/utility/helper';
import { errorTypes } from '@/utility/validation';
import { useEffect, useState } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { callApi, IApiErrorResponse } from '@/api/callApi';
import { API_ENDPOINT, API_URL } from '@/api/constant';
import { IDeleteResponse } from '@/interfaces/common.model';
import MultiSelectSearch from '@/components/ui/MultiSelectSearch';
import { IAddDesignationForm } from '@/interfaces/designation.mode';
import { IDepartmentResponse } from '@/interfaces/department.model';
import ToggleInput from '@/components/ui/ToggleInput';
import FullPageLoader from '@/components/loader/FullPageLoader';
const AddDesignation: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [dataLoading, setdataLoading] = useState<boolean>(false);
  const [selectedMenuBars, setSelectedMenuBars] = useState<string[]>([]);
  const {
    handleSubmit,
    register,
    reset,
    control,
    formState: { errors, isSubmitted },
  } = useForm<IAddDesignationForm>();
  const onSubmit: SubmitHandler<IAddDesignationForm> = async (data) => {
    if (selectedMenuBars?.length == 0) {
      showToastNotification('danger', 'Please select menus bars');
      return;
    }
    const submitData = {
      ...data,
      isActive: location?.state?.data ? data?.isActive : true,
      menuBar: { keyNames: selectedMenuBars },
    };
    setIsLoading(true);
    try {
      const response: IDeleteResponse = await callApi(
        location?.state?.data
          ? API_URL +
              API_ENDPOINT.updateDesignation +
              '?designationId=' +
              location?.state?.data?.id
          : API_URL + API_ENDPOINT.addDesignation,
        {
          method: 'POST',
          data: submitData,
        },
      );
      if (response?.status) {
        showToastNotification('success', response?.message);
        navigate(-1);
      }
    } catch (error: unknown) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleMenuBarSelect = (selected: string[]) => {
    setSelectedMenuBars(selected);
  };
  const getDepartment = async (
    inputValue?: string,
  ): Promise<ISelectOption[]> => {
    // setdataLoading(true);
    try {
      const API = `${API_URL}${API_ENDPOINT.getDepartment}?search=${inputValue || ''}`;
      const response: IDepartmentResponse = await callApi(API, {
        method: 'GET',
      });

      if (response.status && response.data?.department?.length) {
        return response.data.department.map((dep) => ({
          value: dep.id,
          label: dep.name,
        }));
      }

      return [];
    } catch (error) {
      console.error('Error fetching departments:', error);
      return [];
    } finally {
      // setdataLoading(false);
    }
  };
  useEffect(() => {
    if (location?.state?.data) {
      setdataLoading(true);
      const data = location?.state?.data;

      const menu =
        typeof data?.menuBar == 'string'
          ? JSON.parse(data?.menuBar)
          : data?.menuBar;
      reset({
        name: data?.designation || '',
        departmentId: data?.departmentId,
        level: data?.level || '',
        canAccessTeam: data?.canAccessTeam,
        isActive: data?.toggleStatus,
      });
      setSelectedMenuBars(menu?.keyNames);
      setdataLoading(false);
    }
  }, [location.state?.data, reset]);
  return (
    <Layout>
      {dataLoading ? (
        <FullPageLoader />
      ) : (
        <div className="content container-fluid">
          <BackButton label=" Designation" isEdit={location?.state?.data} />
          <form onSubmit={handleSubmit(onSubmit)}>
            <CardLayout>
              <div className="tab-content " id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-BasicDetails"
                  role="tabpanel"
                  aria-labelledby="pills-BasicDetails-tab"
                  tabIndex={0}
                >
                  <div className="row">
                    <FieldLayout fieldStyle="col-12 col-lg-6">
                      <PrimaryInput
                        required={true}
                        errors={errors?.name?.message}
                        label="Name"
                        type="text"
                        placeholder="Enter Designation Name"
                        {...register('name', {
                          ...errorTypes.required(),
                          pattern: {
                            value: /^[A-Za-z][A-Za-z\s/.-]*[A-Za-z]$/,

                            message: 'Invalid name',
                          },
                          maxLength: {
                            value: 100,
                            message: 'Name should not exceed 160 characters',
                          },
                        })}
                      />
                    </FieldLayout>
                    <FieldLayout fieldStyle="col-12 col-lg-6">
                      <Label required={true} id="departmentId">
                        Deparment
                      </Label>
                      <Controller
                        control={control}
                        name="departmentId"
                        rules={errorTypes.required('Department')}
                        render={({ field }) => (
                          <SearchSelectBox
                            value={field.value}
                            title="Select department"
                            onChange={(option) =>
                              field.onChange(option?.value || '')
                            }
                            isAsync
                            fetchOptions={getDepartment}
                            defaultFetch
                            disable={isLoading}
                            isUsingFilter
                          />
                        )}
                      />
                      <ErrorMessage message={errors?.departmentId?.message} />
                    </FieldLayout>
                    <FieldLayout fieldStyle="col-12 col-lg-6">
                      <PrimaryInput
                        required={true}
                        errors={errors?.level?.message}
                        label="Level"
                        placeholder="Enter level"
                        type="text"
                        {...register('level', {
                          ...errorTypes.required('level'),
                          ...errorTypes.level,
                        })}
                      />
                    </FieldLayout>

                    <FieldLayout fieldStyle="col-12 col-lg-6">
                      <Label id={'menubars'} required={true}>
                        Menu bars
                      </Label>
                      <MultiSelectSearch
                        selectedOption={selectedMenuBars}
                        placeholder={'select menus'}
                        options={menuBars}
                        handleChange={handleMenuBarSelect}
                      />
                      {isSubmitted && selectedMenuBars.length === 0 && (
                        <ErrorMessage message="Please select menu bars" />
                      )}
                    </FieldLayout>
                  </div>
                  <div className="d-flex gap-3">
                    <ToggleInput
                      id="canAccessTeamYes"
                      label="Can Access Team"
                      fieldStyle="col-12 col-lg-6"
                      {...register('canAccessTeam', {})}
                      className={`form-check-input rounded-4 ${
                        errors.canAccessTeam ? 'is-invalid' : ''
                      }`}
                    />
                  </div>
                  <FormButtons
                    isLoading={isLoading}
                    buttonStyle="gap-3 mt-4 mb-3"
                  >
                    {' '}
                    {location?.state?.data?.id ? 'Update' : 'Add'}
                  </FormButtons>
                </div>
              </div>
            </CardLayout>
          </form>
        </div>
      )}
    </Layout>
  );
};
export default AddDesignation;
